<div
  class="search-menu-select-chosen"
  [ngClass]="{'disable': selectDisabled(),
              'copy': !isTemplateSelector,
              'select': isTemplateSelector}"
  [matTooltip]="isTemplateSelector ? ('TRANS__SELECTOR__HELP_TEXT_SELECT_TEMPLATE' | translate) :
                                     (('TRANS__SELECTOR__HELP_TEXT_BEFORE' | translate) + ' ' +
                                     (searchContainer.selectButtonText | translate) + ' ' +
                                     ('TRANS__SELECTOR__HELP_TEXT_AFTER' | translate))"
  matTooltipPosition="above"
  [matTooltipDisabled]="!selectDisabled()"
>
  <button
    mat-flat-button
    class="search-menu-select-chosen__button"
    color="accent"
    (click)="select()"
    [disabled]="selectDisabled()"
  >
    @if (isTemplateSelector) {
      <mat-icon>
        check
      </mat-icon>
    }
    @else {
      <i class="icon-select1"></i>
    }

    <span class="bold">
      {{ (searchContainer.selectButtonText ?? 'TRANS__SELECTOR__SELECT_OBJECT') | translate }}
    </span>
  </button>
</div>
